import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class BankingDetailsService {

  constructor(private http: HttpClient) { }

  enterBankingDetails(bankingDetails){
    return this.http.post<any>(environment.apiBaseUrl+`/customer/enter-banking-details`, bankingDetails)
  }
}
